import { Box, Button, FormControl, FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core'
import React from 'react'
import { CSVLink, CSVDownload } from 'react-csv'
import CloseIcon from './CloseIcon'
import CustomButton from './CustomButton'
import CustomDialog from './CustomDialog'
import CustomHeading from './CustomHeading'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import CsvDownload from 'react-json-to-csv'

const useStyles = makeStyles((theme) => ({
  heading: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      padding: '40px 0px 40px 40px',
      fontWeight: 'bold',
    },
  },
  button: {
    width: '190px',
    display: 'flex',
    marginLeft: 'auto',
  },
  tableFooter: {
    margin: '50px 0px 30px 0px',
  },
  dialog: {
    minWidth: '400px',
  },
  heading2: {
    textAlign: 'center',
  },
  button2: {
    // marginTop: '20px',
    width: '150px',
    display: 'flex',
    margin: '20px auto 0px auto',
    padding: '7px 0px',
  },
  newButton: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    display: 'flex',
    margin: '0px auto',
    borderRadius: '10px',
    marginTop: '20px',
    padding: '7px 7px',
  },
}))

export default function DownloadOptionDialog({ open, handleClose, headers, data, heading }) {
  //console.log(headers, data)
  const classes = useStyles()
  const [downloadType, setDownloadType] = React.useState('csv')
  //console.log('DOWNLOAD TYPE : ', downloadType)

  const exportXLS = () => {}

  const exportPDF = () => {
    const unit = 'pt'
    const size = 'A4' // Use A1, A2, A3 or A4
    const orientation = 'portrait' // portrait or landscape
    const marginLeft = 40
    const doc = new jsPDF(orientation, unit, size)

    doc.setFontSize(15)

    const title = heading === 'Manage SubCategory' ? 'Sub Category' : 'Category'
    const headers = [['Name', 'Description']]
    const SubCategoryheaders = [['Name', 'Category Name', 'Description']]
    const tempData = data.map((item) => [item.categoryName, item.description])

    const tempSubCategoryData = data.map((item) => [item.subcategoryName, item.categoryName, item.description])
    let content = {
      startY: 50,
      head: heading === 'Manage SubCategory' ? SubCategoryheaders : headers,
      body: heading === 'Manage SubCategory' ? tempSubCategoryData : tempData,
    }

    doc.text(title, marginLeft, 40)
    doc.autoTable(content)
    doc.save(heading === 'Manage SubCategory' ? 'subcategory.pdf' : 'category.pdf')
    return handleClose()
  }

  // const download =  ?  : null
  return (
    <CustomDialog open={open} handleClose={handleClose} className={classes.dialog}>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading="Download" className={classes.heading2} />
        <CloseIcon handleClose={handleClose} />
      </Box>
      <br />
      <FormControl component="fieldset">
        <RadioGroup name="downloadType" value={downloadType} onChange={(event) => setDownloadType(event.target.value)} row>
          <FormControlLabel value="csv" control={<Radio />} label="CSV" />
          <FormControlLabel value="pdf" control={<Radio />} label="PDF" style={{ marginLeft: '40px' }} />
          {/* <FormControlLabel value="xls" control={<Radio />} label="XLS" style={{ marginLeft: '40px' }} /> */}
        </RadioGroup>
      </FormControl>
      <br />
      {/* <Button> */}

      {downloadType === 'csv' && headers && data && (
        // <CSVLink
        //   headers={headers}
        //   data={data}
        //   filename={heading === 'Manage SubCategory' ? 'subcategory.csv' : 'category.csv'}
        //   target="_blank"
        //   className={classes.button2}
        // >
        //   Go
        // </CSVLink>

        <CsvDownload data={data} filename={heading === 'Manage SubCategory' ? 'subcategory.csv' : 'category.csv'} className={classes.newButton} />
      )}

      {downloadType === 'pdf' && <CustomButton text="Go" className={classes.button2} handleSubmit={exportPDF} />}

      {downloadType === 'xls' && <CustomButton text="Go" className={classes.button2} handleSubmit={exportXLS} />}

      {/* </Button> */}
    </CustomDialog>
  )
}
